import { Chip, Typography } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { ReturnsEditButton } from "../../ui/ReturnsEditButton";

const NavigateToAwbOrder = ({ awbNo }: { awbNo: string }) => {
  const location = useLocation();

  return (
    <Link
      to={`/returns/details/${awbNo}`}
      state={{ prevurl: location.pathname + location.search }}
    >
      <Typography fontWeight={600} color={"#004982"}>
        {awbNo}
      </Typography>
    </Link>
  );
};

export const NavigateToTrakingReturns = ({ return_id, awbNo }: { return_id: string, awbNo: string }) => {
  const location = useLocation();

  return (
    <Link
      target={"_blank"}
      to={`/tracking/${return_id}`}
      state={{ prevurl: location.pathname + location.search }}
    >
      <Typography fontWeight={600} color={"#004982"}>
        {awbNo}
      </Typography>
    </Link>
  );
};


export interface returnRowType {
  awb: string;
  receiver: string;
  status: string;
  to: string;
  from: string;
  description: string;
  vendor: any;
  amount: number;
  id: number;
  ReturnDetails: string;
  BuyerDetails: string;
  ProductDetails: string;
  RetrunReason: string;
  RefundDetails: string;
  Status: string;
  Action?: string;
}

export interface ReturnColType {
  field: string;
  headerName: string;
  width: number;
  renderCell?: (params: { row: GridRowModel }) => JSX.Element;
}

export const returnColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingReturns return_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  // {
  //   field: "pickup_number",
  //   headerName: "Pickup Number",
  //   minWidth: 140,
  //   flex: 1,
  // },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `$${params.row.amount}` : ""}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <ReturnsEditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },

  // {
  //   field: "id",
  //   headerName: "ID",
  //   minWidth: 50,
  //   renderCell: (params: { row: GridRowModel }) => (
  //     <>
  //       <NavigateToAwbOrder awbNo={params.row.id} />
  //     </>
  //   ),
  // },
  // { field: "aws", headerName: "AWS", width: 70 },
  // {
  //   field: "description",
  //   headerName: "Description",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "from",
  //   headerName: "From",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "to",
  //   headerName: "To",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // { field: "shipper", headerName: "Shipper", minWidth: 140, flex: 1 },
  // { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   minWidth: 140,
  //   flex: 1,

  //   renderCell: (params: { row: GridRowModel }) => (
  //     <Chip
  //       sx={{
  //         padding: "1px 1px",
  //       }}
  //       label={params.row.status}
  //       variant="outlined"
  //       color="success"
  //     />
  //   ),
  // },
  // {
  //   field: "Action",
  //   headerName: "Action",
  //   minWidth: 200,
  //   flex: 1,

  //   renderCell: (params: { row: GridRowModel }) => (
  //     <EditButton id={params.row.id} />
  //   ),
  // },
];



export const returnPikupColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingReturns return_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickup_number",
    headerName: "Pickup Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `$${params.row.amount}` : ""}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <ReturnsEditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];


export const returnsReadyToShipColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },

  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `$${params.row.amount}` : ""}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <ReturnsEditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];

export const returnsCancelColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingReturns return_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickup_number",
    headerName: "Pickup Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `$${params.row.amount}` : ""}
      </Typography>
    ),
  },
  { field: "comments", headerName: "Remark", minWidth: 140, flex: 1 },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <ReturnsEditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];


export const TabCol = [
  {
    index: 0,
    column: returnsReadyToShipColumns,
  },
  {
    index: 1,
    column: returnColumns,
  },
  {
    index: 2,
    column: returnPikupColumns,
  },
  {
    index: 3,
    column: returnColumns,
  },
  {
    index: 4,
    column: returnColumns,
  },
  {
    index: 5,
    column: returnColumns,
  },
  {
    index: 6,
    column: returnColumns,
  },
  {
    index: 7,
    column: returnColumns,
  },
  {
    index: 8,
    column: returnsCancelColumns,
  },
  {
    index: 9,
    column: returnColumns,
  },
  {
    index: 10,
    column: returnColumns,
  },
];
